/** @jsx h */
import { h } from "hyperapp";
import nestable from "hyperapp-nestable";
import bus from "../../../bus";
import { playerEvents, queueEvents, mastheadPlayerEvents } from "../../events";
import { mergeStateAction, WrappedSvg } from "../../../utilities/hyperapp";

import downArrowIcon from "!svg-inline-loader?removeSVGTagAttrs=false!../../../button/down-arrow.svg";

export default function Track({ item, isCurrentItem }) {
  function play() {
    if (!isCurrentItem) {
      bus.emit(queueEvents.SET_CURRENT, {
        items: [item.player_item],
        callback: () => {
          bus.emit(playerEvents.SET, {
            status: "playing",
            target: {
              type: "queue"
            }
          });
        }
      });
    } else {
      bus.emit(playerEvents.SET, {
        status: "playing",
        target: {
          type: "queue"
        }
      });
    }
  }

  function playNext() {
    bus.emit(queueEvents.PREPEND, [item.player_item]);
    bus.emit(mastheadPlayerEvents.WIGGLE);
  }

  function addToQueue() {
    bus.emit(queueEvents.APPEND, [item.player_item]);
    bus.emit(mastheadPlayerEvents.WIGGLE);
  }

  return (
    <li class="player-recommended-item d-flex flex-items-v-center">
      <button
        onclick={e => {
          e.preventDefault();
          play();
        }}
        ga-on="click,auxclick,contextmenu"
        ga-event-category="audio"
        ga-event-action={"play"}
        ga-event-label={item.player_item.data.title}
        class="d-flex flex-items-v-center flex-1 t-left"
      >
        {item.preview_image_url ? (
          <img
            class="player-recommended-item__image"
            alt=""
            src={item.preview_image_url}
          />
        ) : (
          <div
            class={`player-recommended-item__image-proxy bg-${item.display_color}`}
          />
        )}
        <div class="player-recommended-item__details">
          <h3 class="player-recommended-item__title">
            {item.player_item.data.title}
          </h3>
          <h4>{item.player_item.data.subtitle}</h4>
        </div>
      </button>
      <TrackActions
        itemPath={item.path}
        play={play}
        playNext={playNext}
        addToQueue={addToQueue}
        title={item.player_item.data.title}
      />
    </li>
  );
}

const TrackActions = nestable(
  {
    el: null,
    active: false
  },
  {
    setActive: active => (state, actions) => {
      if (active === state.active) {
        return;
      }

      if (active) {
        window.addEventListener("click", actions.onClickOutside);
      } else {
        window.removeEventListener("click", actions.onClickOutside);
      }

      return { active };
    },
    onCreate: el => (state, actions) => {
      return { el };
    },
    onDestroy: el => (state, actions) => {
      window.removeEventListener("click", actions.onClickOutside);
    },
    onClickOutside: e => (state, actions) => {
      const clickedOutside = !(
        state.el === e.target || state.el.contains(e.target)
      );
      if (clickedOutside) {
        actions.setActive(false);
      }
    }
  },
  ({ active, title }, { onCreate, onDestroy, setActive }) => ({
    itemPath,
    play,
    playNext,
    addToQueue
  }) => {
    return (
      <div class="dropdown t-left" oncreate={onCreate} ondestroy={onDestroy}>
        <button
          class="player-queue-track__actions-button"
          onclick={e => {
            e.stopPropagation();
            e.preventDefault();
            setActive(!active);
          }}
        >
          <span class="hide-visually">Show actions for track</span>
          <span class="player-queue-track__actions-icon">
            <WrappedSvg data={downArrowIcon} />
          </span>
        </button>
        {active ? (
          <div class="dropdown__content dropdown__content--active dropdown__content--right-aligned">
            <ul class="dropdown__list t-alternate">
              <li class="dropdown__item">
                <a
                  onclick={e => {
                    setActive(false);
                  }}
                  class="dropdown__anchor t-left"
                  href={itemPath}
                >
                  View item
                </a>
              </li>
              <li class="dropdown__item">
                <button
                  onclick={e => {
                    e.preventDefault();
                    setActive(false);
                    play();
                  }}
                  ga-on="click,auxclick,contextmenu"
                  ga-event-category="audio"
                  ga-event-action={"play"}
                  ga-event-label={title}
                  class="dropdown__anchor t-left"
                >
                  Play
                </button>
              </li>
              <li class="dropdown__item">
                <button
                  onclick={e => {
                    e.preventDefault();
                    setActive(false);
                    playNext();
                  }}
                  class="dropdown__anchor t-left"
                  ga-on="click,auxclick,contextmenu"
                  ga-event-category="audio"
                  ga-event-action="play next"
                  ga-event-label={title}
                >
                  Play next
                </button>
              </li>
              <li class="dropdown__item">
                <button
                  onclick={e => {
                    e.preventDefault();
                    setActive(false);
                    addToQueue();
                  }}
                  class="dropdown__anchor t-left"
                  ga-on="click,auxclick,contextmenu"
                  ga-event-category="audio"
                  ga-event-action="play next"
                  ga-event-label={title}
                >
                  Add to queue
                </button>
              </li>
            </ul>
          </div>
        ) : null}
      </div>
    );
  }
);
